import React, { useEffect, useRef } from 'react';
import renderMathInElement from 'katex/dist/contrib/auto-render';
import 'katex/dist/katex.min.css';

// Delimiters KaTeX auto-render will typeset. We deliberately do NOT enable a bare
// single-`$...$` inline delimiter: existing posts use `$` in prose (e.g. "$100
// million", "shoes for $50"), and turning those into math would wreck them. Posts
// published through the pipeline have their `$...$` / `$$...$$` converted to
// \(...\) / \[...\] by the arithmatex Markdown extension, which only matches real
// math spans — so inline math still renders, prose dollars stay literal. `$$...$$`
// is kept for display math written directly as a string.
const DELIMITERS = [
  { left: '$$', right: '$$', display: true },
  { left: '\\[', right: '\\]', display: true },
  { left: '\\(', right: '\\)', display: false },
];

// Renders a stored HTML string (see assets/blogposts.js) and typesets any math it
// contains with KaTeX. Used anywhere a blog post's `html` is shown.
const PostHtml = ({ html }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    renderMathInElement(ref.current, {
      delimiters: DELIMITERS,
      throwOnError: false,
      ignoredTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code'],
    });
  }, [html]);

  return <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default PostHtml;
